import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Alert, CircularProgress } from '@mui/material';

import { useQuery } from '@apollo/client';
import { SKU_QUERY } from './gql';
import { filterSelector } from 'helper/filter';
import { ErrorAlert, RedirectError } from 'pages/error';

interface SKUProps {
  sku: string;
}

export default function SKU(props: SKUProps) {
  const navigate = useNavigate();

  const skuQuery = useQuery(SKU_QUERY, {
    variables: {
      sku: props.sku,
    },
  });

  const loading = skuQuery.loading;
  const error = skuQuery.error;

  if (loading) return <CircularProgress />;
  else if (error) return <RedirectError err={error} />;
  else if (skuQuery.data!.listProducts.products.length > 0) {
    navigate(`/products/products/${skuQuery.data!.listProducts.products[0].id}`);
    return null;
  } else if (skuQuery.data!.listProductBundles.bundles.length > 0) {
    navigate(`/products/bundles/${skuQuery.data!.listProductBundles.bundles[0].id}`);
    return null;
  } else if (skuQuery.data!.listFacilities.facilities.length > 0) {
    navigate(`/products/facilities/${skuQuery.data!.listFacilities.facilities[0].id}`);
    return null;
  } else if (skuQuery.data!.listServiceTypes.serviceTypes.length > 0) {
    navigate(`/servicetypes/${skuQuery.data!.listServiceTypes.serviceTypes[0].id}`);
    return null;
  } else {
    return <ErrorAlert err={`SKU {props.sku} invalid`} />;
  }
}
